import E from '@unseenco/e'

export default E
